<template>
  <ModalDialog
    ref="dialog"
    :title="`Available Block List`"
    icon="fa-box"
    :showSubmit="false"
    :scrollable="true"
    @closed="onClosed">

    <Spinner v-if="loading" />
    <div v-if="!loading">
      <div class="row">
        <div class="col-12">
          <ReportFilterPopover
            class="float-right mr-2"
            headerTitle="Glass Block Filter"
            :showApplyButton="true"
            :showResetButton="true"
            :filterActive="hasFilterActive"
            placement="left"
            @apply="applyBlockFilter"
            @reset="resetBlockFilter">
            <template v-slot:popover>
              <ReportFilterGroup label="Account Location">
                <ReportMultiSelect :options="accountLocationLookup" v-model="editingBlockFilter.accountLocationList" />

              </ReportFilterGroup>
            </template>
            <template v-slot:filterDisplay>
              <div v-if="appliedBlockFilter.accountLocationList && appliedBlockFilter.accountLocationList.length > 0">
                <i class="far fa-map-marker-alt mr-2"></i>{{appliedBlockFilter.accountLocationList.length}} Location{{displayCountPlural(appliedBlockFilter.accountLocationList.length)}}
              </div>
            </template>
          </ReportFilterPopover>
          <ContentTitle>Glass Blocks</ContentTitle>
        </div>
      </div>
      <StaticDataTable class="static-table-list">
        <template v-slot:header>
          <tr>
            <th>Received Size (HxW) mm</th>
            <th>Barcode</th>
            <th>Supplier Batch Number</th>
            <th>Total Sheets</th>
            <th>Bin</th>
            <th>Location</th>
            <th>Actions</th>
          </tr>
        </template>
        <template v-slot:body>
          <tr v-for="glassBlock in filteredBlockList" :key="glassBlock.id">
            <td>{{glassBlock.height}} x {{glassBlock.width}}</td>
            <td>{{glassBlock.barcode}}</td>
            <td>{{glassBlock.referenceCode}}</td>
            <td>{{glassBlock.sheetQuantity}}</td>
            <td>{{glassBlock.inventoryBin ? glassBlock.inventoryBin.code : '-'}}</td>
            <td>{{glassBlock.inventoryBin ? glassBlock.inventoryBin.accountLocation.name : '-'}}</td>
            <td>
              <ActionDropMenu :tableAction="true" :forceDropdown="true">
                <DropdownMenuItem v-if="canOpenBlock" @click="openBlock(glassBlock)" icon="fa-box-open">Open Block</DropdownMenuItem>
              </ActionDropMenu>
            </td>
          </tr>
        </template>
        <template v-slot:empty v-if="!filteredBlockList || filteredBlockList.length == 0">No unopened blocks found</template>
      </StaticDataTable>
    </div>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportFilterGroup from '@/components/reporting/reportFilterGroup'
import ReportMultiSelect from '@/components/reporting/reportMultiSelect'
import StaticDataTable from '@/components/table/staticDataTable.vue'

export default {
  name: "GlassBlockListDialog",
  mixins: [
    ModalDialogMixin,
  ],
  components: {
    ModalDialog,
    ReportFilterPopover,
    ReportFilterGroup,
    ReportMultiSelect,
    StaticDataTable
  },
  props: {
    stockId: Number,
    glassSizeId: Number
  },
  data() {
    return {
      loading: false,
      glassBlockList: [],
      accountLocationLookup: [],
      defaultBlockFilter: {    
        accountLocationList: []
      },
      editingBlockFilter: {},
      appliedBlockFilter: {},
    }
  },
  mounted() {
    this.loading = true
    this.editingBlockFilter = _.clone(this.defaultBlockFilter)
    this.appliedBlockFilter = _.clone(this.defaultBlockFilter)

    this.requestData()
  },
  computed: {
    hasFilterActive() {
      return this.appliedBlockFilter.accountLocationList && this.appliedBlockFilter.accountLocationList.length > 0
    },
    canOpenBlock() {
      return this.userHasUpdatePermission(this.PermissionTypes.InventoryPermissionTypes.stock)
    },
    filteredBlockList() {
      return this.glassBlockList.filter(glassBlock => {
        if(this.appliedBlockFilter.accountLocationList.length == 0)
          return true
        if(!glassBlock.inventoryBin || !glassBlock.inventoryBin.accountLocation)
          return false

        return this.appliedBlockFilter.accountLocationList.includes(glassBlock.inventoryBin.accountLocation.id)
      })
    }
  },
  methods: {
    show() {
      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    requestData() {
      this.loading = true
      Promise.all([
        this.$apiService.inventoryService.getGlassBlockList({ stockId: this.stockId, glassSizeId: this.glassSizeId, isOpened: false }),
        this.$apiService.adminService.getAccountLocations()
      ])
      .then(results => {
        this.glassBlockList = results[0].data

        this.accountLocationLookup = results[1].data.filter(location => location.isActive).map((location, index) => {
          return { name: `${location.name}`, value: location.id }
        })
      })
      .finally(() => {
        this.loading = false
      })
    },
    openBlock(glassBlock) {
      this.confirmMessage('Open Block?', 'Open the block? This will convert the block to loose sheets and will mark the block as opened')
      .then(confirm => {
        if(confirm) {
          this.$apiService.inventoryService.openGlassBlock(glassBlock.id)
          .then(response => {
            this.successToast('Block Opened')
            this.requestData()
          })
          .catch(err => {
            this.displayNetworkError(err, 'Error', 'Could not open the block')
          })
        }
      })
    },
    applyBlockFilter() {
      this.appliedBlockFilter = _.clone(this.editingBlockFilter)
    },
    resetBlockFilter() {
      this.editingBlockFilter = _.clone(this.defaultBlockFilter)
      this.appliedBlockFilter = _.clone(this.defaultBlockFilter)
    },
  }
}
</script>